export default __webpack_public_path__ + "static/media/South Dakota.b4a96b2b.jpg";